import React from 'react';
import {
  Box,
  Grid,
  IconButton,
  Typography,
  styled,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Block';
import {
  StewartDialog,
  StewartDialogActions,
  StewartDialogContent,
} from 'controls/global/dialogs/stewart-dialog/StewartDialog';
import ActionButton from 'controls/global/action-button';
import {
  borderRadius,
  colors,
  fontSize,
  fontWeight,
  gradients,
  iconSize,
  padding,
  gaps,
} from 'theme/defaultStyle';

import SelectField from 'controls/global/select-field';
import DatePicker from 'controls/global/datepicker/DatePicker';
import { TextInput } from 'controls/global/text-input-field';


const StyledDialog = styled(StewartDialog)({
  "& > .MuiDialog-container > .MuiDialog-paper": {
    maxWidth: "calc(60vw)",
    minWidth: "calc(60vw)",
    paddingTop: padding.xlarge21,
    paddingRight: padding.xlarge22,
    paddingBottom: padding.zero,
    paddingLeft: padding.xlarge22, 
    overflowX: "hidden",
  },
});

const StyledDialogTitle = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: gaps.large1,
  "& .MuiTypography-root": {
    fontSize: fontSize.xlarge2,
    fontWeight: fontWeight.bold2,
  },
});

const IconContainer = styled(Box)({
  background: gradients.redGradient05,
  borderRadius: borderRadius.large,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "56px",
  height: "56px",
  "& .MuiSvgIcon-root": {
    color: colors.white,
    fontSize: iconSize.medium2,
  },
});

const CloseIconContainer = styled(Box)({
  background: colors.grey10,
  borderRadius: borderRadius.xlarge1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginLeft: "auto",
  width: "32px",
  height: "32px",
  "& .MuiSvgIcon-root": {
    color: colors.blue01,
  },
  "& .iconButton": {
    padding: padding.zero,
  },
});

const StyledDialogAction = styled(StewartDialogActions)({
  justifyContent: "right",
  padding: `${padding.large1} 0 ${padding.xlarge22}`,
});

const gridStyle = {
  paddingTop: padding.small2,
  // paddingRight: padding.small2,
};

type UndoVoidJacketDialogProps = {
  formType: string;
  serialNumber?: string;  
  effectiveDate?: Date | null;
  form?: string;

  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  // schema: string;
  // productIndex: number;
  // // title?: string;
  // buttonText?: string;
};

const UndoVoidJacketDialog = ({ 
  formType,
  serialNumber,
  effectiveDate,
  form,
  isOpen, 
  onClose, 
  onSubmit 
}: UndoVoidJacketDialogProps) => {

  return (
    <StyledDialog
      open={isOpen}
      onClose={onClose}
    >
      <StyledDialogTitle>
        <IconContainer>
          <CancelIcon />
        </IconContainer>
        <Typography>{"Undo Voided Jacket"}</Typography>
        <CloseIconContainer>
          <IconButton
            className="iconButton"
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </CloseIconContainer>
      </StyledDialogTitle>
      <StewartDialogContent>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3} style={gridStyle}>
            <SelectField
              name={`formType`}
              defaultValue={formType}
              disabled={true}
              label="Type"
              options={[
                {
                  text: formType,
                  value: formType,
                },
              ]}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={6} xl={6} style={gridStyle}>
            <TextInput
              label="Policy Number"
              name={serialNumber}
              disabled={true}
              value={serialNumber}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3} lg={3} xl={3} style={gridStyle}>
            <DatePicker
              name={"effectiveDate"}
              label="Effective Date"
              value={effectiveDate}
              disabled={true}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={gridStyle}>
            <TextInput label="Form" name={form} disabled={true} value={form} />
          </Grid>
        </Grid>
      </StewartDialogContent>      

      <StyledDialogAction>
        <ActionButton
          // autoFocus
          variant="outlined"
          color="secondary"
          onClick={onClose}
        >
          Cancel
        </ActionButton>

        <ActionButton
          // autoFocus
          variant="outlined"
          color="primary"
          onClick={onSubmit}
        >
          Undo Void
        </ActionButton>
      </StyledDialogAction>
    </StyledDialog>
  );
};

export default UndoVoidJacketDialog;
